import {postEventResponse} from "../../api/formController";

export const createEventResponse = async ({
                                              eventId,
                                              eventResponse,
                                              setStatusInProgress,
                                              setStatusSuccess,
                                              setStatusFailed,
                                              setStatusError,
                                              setStatusDuplicateError,
                                          }) => {
    setStatusInProgress();
    try {
        const response = await postEventResponse(eventId, eventResponse);
        if (!!response?.success) {
            setStatusSuccess();
        }
        else if (response?.isDuplicate) {
            setStatusDuplicateError();
        }
        else {
            setStatusFailed();
        }
    }
    catch (error) {
        console.error(error);
        setStatusError();
    }
};

